<div id="cms-partial-category-top">
  <!-- ROWS -->

  @if (!isEmpty(get(data, 'rows', ''))) {
    <div id="rows">
      @for (row of get(data, 'rows', []); track row; let i = $index) {
        <div>
          <!-- Hero Banner -->
          @if (get(row, 'category_top_banner', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-hero-banner
                [heroBannerRow]="row"
                [dataUrl]="data.url"
                [dataTitle]="data.title"
              ></cms-partial-category-top-hero-banner>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 400px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 400px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- Cards -->
          @if (get(row, 'cards', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-cards [cardsRow]="row"></cms-partial-category-top-cards>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- Software Stack -->
          @if (get(row, 'software_stack', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-software-stack
                [softwareStackRow]="row"
              ></cms-partial-category-top-software-stack>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- Subcategory Links -->
          @if (get(row, 'subcategory_links', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-subcategory-links
                [subcategoryLinksRow]="row"
              ></cms-partial-category-top-subcategory-links>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 150px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 150px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- Category Top Feature Solutions -->
          @if (get(row, 'feature_solutions', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-feature-solutions
                [featureSolutionsRow]="row"
                [solutionUrl]="data.url"
              ></cms-partial-category-top-feature-solutions>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 400px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 400px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- MULTIPLE COLUMNS GRID -->
          @if (get(row, 'multi_columns', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-multiple-columns
                [multipleColumnsRow]="row"
              ></cms-partial-category-top-multiple-columns>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- TABLE -->
          @if (get(row, 'tables', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-table [tableRow]="row"></cms-partial-category-top-table>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- LEAD GEN -->
          @if (get(row, 'lead_gen', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-lead-gen
                [leadGenRow]="row"
                [dataUrl]="data.url"
                [dataTitle]="data.title"
              ></cms-partial-category-top-lead-gen>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 200px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          @if (get(row, 'colored_block', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-colored-block
                [coloredBlockRow]="row"
                [dataUrl]="data.url"
                [dataTitle]="data.title"
              ></cms-partial-category-top-colored-block>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- LOGOS -->
          @if (get(row, 'logos', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-logos [logosRow]="row"></cms-partial-category-top-logos>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 100px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- Paragraph -->
          @if (get(row, 'paragraph', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-paragraph
                [paragraphRow]="row"
              ></cms-partial-category-top-paragraph>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 150px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 150px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
          <!-- IMAGE AND TEXT -->
          @if (get(row, 'image_and_text', '')) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-image-and-text
                [imageAndTextRow]="row"
                [index]="i"
              ></cms-partial-category-top-image-and-text>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 250px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 250px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
        </div>
      }
    </div>
  }
  <!-- ROW SET (Product Facets) -->

  @if (!isEmpty(get(data, 'rowSets', ''))) {
    <div id="row-sets">
      @for (rowSet of get(data, 'rowSets', []); track rowSet) {
        <div>
          @if (!isEmpty(get(rowSet, 'products.category_top_facets[0]', ''))) {
            @defer (on viewport; prefetch on idle) {
              <cms-partial-category-top-row-set
                [rowSetData]="rowSet"
              ></cms-partial-category-top-row-set>
            } @placeholder {
              <div class="skeleton-loader" style="min-height: 300px;"></div>
            } @loading (minimum 200ms) {
              <div class="loading-spinner" style="min-height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="spinner"></div>
              </div>
            }
          }
        </div>
      }
    </div>
  }
</div>
